import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ITrack } from '../../../../Interface/track'
import { TracksService } from '../../../../services/tracks.service'

@Component({
  selector: 'bmcore-top-day-seller',
  templateUrl: './bmcore-top-day-seller.component.html',
  styleUrls: ['./bmcore-top-day-seller.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTopDaySellerComponent implements OnInit {
  pageSize = 12
  tracks: Array<ITrack> = []

  constructor(private tracksService: TracksService) {}

  ngOnInit(): void {
    this.tracksService.getTopDaySellerBeats(this.pageSize).subscribe(res => {
      this.tracks = res.items
    })
  }
}
